import { phoneUsRegex, emailRegex, phoneIntRegex } from "./regex";

export const validateEmail = (email) => emailRegex.test(email);

export const validatePhone = (phone) => phoneUsRegex.test(phone);

export const validatePhoneInt = (phone) => phoneIntRegex.test(phone);
